import React, { useState } from 'react';


function FullScreen() {

    const [isFullscreen, setIsFullscreen] = useState(false);

    // Detecta el cambio de fullscreen sin useEffect
    document.onfullscreenchange = () => {
        setIsFullscreen(document.fullscreenElement != null);
    };

    return (
        <div>
            {/* ...existing code... */}
            <button
                className="p-2 bg-secondary bg-opacity-10 rounded-3 text-secondary h-100 " 
        
                onClick={() => {
                    if (!isFullscreen) {
                        document.documentElement.requestFullscreen?.();
                        document.documentElement.webkitRequestFullscreen?.();
                        document.documentElement.msRequestFullscreen?.();
                    } else {
                        document.exitFullscreen?.();
                        document.webkitExitFullscreen?.();
                        document.msExitFullscreen?.();
                    }
                }}
            >
                {isFullscreen ?<><i class="uil uil-minus-square-full" title='Minimizar'></i> <span>Minimizar</span></>  
                :<><i class="uil uil-external-link-alt" title='Expandir'></i><span>Expandir</span></>}
            </button>
            {/* ...existing code... */}
        </div>
    )
}

export default FullScreen

